import { useEffect } from 'react';

/**
 * De browser om een bevestiging laten vragen voordat de pagina verdwijnt.
 *
 * Een consult staat volledig in het geheugen van de tab: het transcript, de
 * sprekerrollen, de nog niet verzonden SOEP. Er is geen concept op de server -- dat
 * is met opzet zo, want gespreksinhoud hoort niet langer te blijven staan dan het
 * consult duurt. De keerzijde is dat een per ongeluk gesloten tab of venster alles
 * weggooit, en tot nu toe gebeurde dat zonder één vraag.
 *
 * `beforeunload` is het enige aangrijpingspunt dat de browser daarvoor biedt. Twee
 * dingen om te weten bij het lezen van deze code:
 *
 *   - De tekst in het dialoogvenster komt van de browser en is niet aan te passen.
 *     Een eigen melding meegeven werkt sinds 2016 niet meer; alleen het ja/nee komt
 *     terug, en zelfs dát krijgt deze code niet te zien.
 *   - De vraag verschijnt alleen als de gebruiker de pagina heeft aangeraakt
 *     (sticky activation). Voor dit scherm is dat geen beperking: wie een opname
 *     start heeft op de opnameknop gedrukt.
 *
 * Dit dekt het sluiten van de tab, het venster en een herlaadactie. Navigeren
 * binnen de applicatie gaat er langs -- react-router verlaat de pagina niet -- maar
 * de plekken waar dat kan (instellingen, handleiding) zijn knoppen die iemand
 * bewust indrukt, en geen ongeluk zoals het wegklikken van een tab.
 */
export function useWaarschuwBijVerlaten(actief: boolean): void {
  useEffect(() => {
    if (!actief) return;

    const bijVerlaten = (gebeurtenis: BeforeUnloadEvent) => {
      gebeurtenis.preventDefault();
      // Voor browsers die nog op de oude manier kijken; Chrome vóór 119 negeert een
      // kaal preventDefault().
      gebeurtenis.returnValue = '';
    };

    window.addEventListener('beforeunload', bijVerlaten);
    return () => window.removeEventListener('beforeunload', bijVerlaten);
  }, [actief]);
}
